import { Record } from 'immutable';
import Logger from 'app/services/logger';
import sendPayloadToFluentd, { FluentdNetworkError } from 'app/services/fluentdLogger/fluentd';
import { getUserAgent } from 'app/utils/env';
import { getGlobalHistory } from 'app/services/history';

const RESEND_TIMEOUT = 5000;

export const TRACE = 'TRACE';
export const DEBUG = 'DEBUG';
export const INFO = 'INFO';
export const WARN = 'WARN';

const LogLevel = (Record({
  [TRACE]:  0,
  [DEBUG]:  1,
  [INFO]:   2,
  [WARN]:   3,
}, 'LogLevel'))();

// Persisted logging state that will be sent with each call to `log`.
let persistedContext = {};

// Whether or not the logger is disabled.
let disabled = false;

// The minimal level to listen for when logging.
let listenLogLevel = TRACE;

const FluentdLogger = {
  trace: (logRecord) => { log(logRecord, TRACE); },
  debug: (logRecord) => { log(logRecord, DEBUG); },
  info: (logRecord) => { log(logRecord, INFO); },
  warn: (logRecord) => { log(logRecord, WARN); },

  clearContext: () => {
    persistedContext = {};
  },

  disable: () => {
    disabled = true;
  },

  enable: () => {
    disabled = false;
  },

  /**
   * @param {String} field
   * @param {Any} value
   */
  setContext: (field, value) => {
    if (value === undefined) {
      delete persistedContext[field];
    } else {
      persistedContext[field] = value;
    }
  },

  /**
   * @param {TRACE|DEBUG|INFO|WARN}
   */
  setLogLevel: (logLevel) => {
    if (!LogLevel.has(logLevel)) {
      throw new Error(`${logLevel} is not a valid log level.`);
    }

    listenLogLevel = logLevel;
  },
};

export default FluentdLogger;

/**
 * @param {Object} context                    map containing key/pair context values
 * @param {TRACE|DEBUG|INFO|WARN} logLevel
 */
function log(context, logLevel) {
  try {
    if (disabled || LogLevel.get(logLevel) < LogLevel.get(listenLogLevel)) {
      return;
    }

    const date = new Date();

    const logRecord = {
      ...persistedContext,
      ...context,
      severity: logLevel,
      user_timestamp: date.toISOString(),
      user_timezone_offset: date.getTimezoneOffset(),
      http_host: getGlobalHistory().location.hostname,
      path: getGlobalHistory().location.pathname,
      agent: getUserAgent(),
    };

    const payloadString = JSON.stringify(logRecord);

    sendPayloadToFluentd(payloadString, {
      onError: (firstSendError) => {
        if (firstSendError instanceof FluentdNetworkError) {
          // Try sending again, one more time.
          setTimeout(() => sendPayloadToFluentd(payloadString), RESEND_TIMEOUT);
        }
      },
    });
  } catch (err) {
    Logger.error(err);
  }
}
